module.exports = __webpack_public_path__ + "img/4.8395fe77.jpg";